import { Routes, Route, Navigate } from "react-router-dom"
import Assignations from "./assignations"
import AssignationsLayout from "./layout"
import Presssignations from "./preassignations"
import MySubstitutions from "./my-substitutions"
import SubstitutionRequests from "./substitution-requests"
import CreatePreassignation from "./preassignations/create"

const AssignationsRouter = () => (
  <Routes>
    <Route index element={<Navigate to="assignations" replace />} />
    <Route element={<AssignationsLayout />}>
      <Route path="assignations" element={<Assignations />} />
      <Route path="preassignations" element={<Presssignations />} />
      <Route path="preassignations/create" element={<CreatePreassignation />} />
      <Route path="my-substitutions" element={<MySubstitutions />} />
      <Route path="substitution-requests" element={<SubstitutionRequests />} />
    </Route>
  </Routes>
)

export default AssignationsRouter
